import { useRef, useEffect, useCallback } from 'react';
import { handledKeys, keysX, keysY, active, getScope, getFocusables, isInsideScope, initTabIndexes, createId, } from './utils';
export const useArrowNav = (props = {}) => {
    const { disabled = false, focusableSelector = {}, handleX = true, handleY = true, loop = true, onKeyDown, scope, tabIndexGroup = true, } = props;
    const keynavId = useRef(createId());
    const containerRef = useRef(null);
    const scp = useCallback(() => (scope ? getScope(scope) : getScope(containerRef)), [scope]);
    let disabledOnce = false;
    const disableOnce = () => (disabledOnce = true);
    const handleKeydown = (e) => {
        var _a;
        if (![...handledKeys].includes(e.key))
            return; // Proper key wasn't pressed
        if (!handleX && keysX.includes(e.key))
            return;
        if (!handleY && keysY.includes(e.key))
            return;
        if (!isInsideScope(scp(), active(), keynavId.current))
            return;
        const focusables = getFocusables(scp(), focusableSelector, loop, e.key, keynavId.current);
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e, {
            active: focusables.active,
            next: focusables.next,
            disableOnce,
        });
        if (disabledOnce) {
            disabledOnce = false; // Re-enable hook action
            return;
        }
        e.preventDefault(); // Prevent scrolling
        (_a = focusables.next) === null || _a === void 0 ? void 0 : _a.focus(); // Main routine
    };
    // Effect for setting keynav id attribute
    useEffect(() => {
        if (disabled)
            return;
        const scopeElements = scp();
        scopeElements.forEach((el) => (el.dataset.keynav = keynavId.current));
        return () => scopeElements.forEach((el) => delete el.dataset.keynav);
    }, [disabled, scope]); // eslint-disable-line
    // Effect for key listeners
    useEffect(() => {
        if (disabled)
            return;
        const scopeElements = scp();
        if ((scopeElements === null || scopeElements === void 0 ? void 0 : scopeElements.length) < 1)
            return;
        scopeElements.forEach((el) => el.addEventListener('keydown', handleKeydown));
        return () => {
            scopeElements.forEach((el) => el.removeEventListener('keydown', handleKeydown));
        };
    }, [disabled, scope, loop, handleX, handleY, tabIndexGroup, compare(focusableSelector)]); // eslint-disable-line
    // Effect for tab grouping, to be fired on each re-render
    useEffect(() => {
        if (!tabIndexGroup || disabled)
            return;
        const cleanTabIndexes = initTabIndexes(scp(), focusableSelector, keynavId.current);
        return () => cleanTabIndexes === null || cleanTabIndexes === void 0 ? void 0 : cleanTabIndexes.forEach((clearFn) => clearFn === null || clearFn === void 0 ? void 0 : clearFn());
    }, [disabled, scope, tabIndexGroup, compare(focusableSelector), {}]); // eslint-disable-line
    // Returns ref of the container if scope was not set
    if (!scope)
        return containerRef;
};
const compare = (prop) => JSON.stringify(prop, ['selector', 'extendSelector']);
//# sourceMappingURL=useArrowNav.js.map